import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IDiningDetails } from 'app/shared/model/dining-details.model';
import { getEntities as getDiningDetails } from 'app/entities/dining-details/dining-details.reducer';
import { ICusine } from 'app/shared/model/cusine.model';
import { getEntity, updateEntity, createEntity, reset } from './cusine.reducer';

export const CusineUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const diningDetails = useAppSelector(state => state.diningDetails.entities);
  const cusineEntity = useAppSelector(state => state.cusine.entity);
  const loading = useAppSelector(state => state.cusine.loading);
  const updating = useAppSelector(state => state.cusine.updating);
  const updateSuccess = useAppSelector(state => state.cusine.updateSuccess);

  const handleClose = () => {
    navigate('/cusine' + location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDiningDetails({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.createdDate = convertDateTimeToServer(values.createdDate);
    values.modifiedDate = convertDateTimeToServer(values.modifiedDate);

    const entity = {
      ...cusineEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          createdDate: displayDefaultDateTime(),
          modifiedDate: displayDefaultDateTime(),
        }
      : {
          ...cusineEntity,
          createdDate: convertDateTimeFromServer(cusineEntity.createdDate),
          modifiedDate: convertDateTimeFromServer(cusineEntity.modifiedDate),
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="activitiesApp.cusine.home.createOrEditLabel" data-cy="CusineCreateUpdateHeading">
            <Translate contentKey="activitiesApp.cusine.home.createOrEditLabel">Create or edit a Cusine</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="cusine-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('activitiesApp.cusine.active')}
                id="cusine-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('activitiesApp.cusine.cusineCode')}
                id="cusine-cusineCode"
                name="cusineCode"
                data-cy="cusineCode"
                type="text"
              />
              <ValidatedField
                label={translate('activitiesApp.cusine.cusineName')}
                id="cusine-cusineName"
                name="cusineName"
                data-cy="cusineName"
                type="text"
              />
              <ValidatedField
                label={translate('activitiesApp.cusine.cusine')}
                id="cusine-cusine"
                name="cusine"
                data-cy="cusine"
                type="text"
              />
              <ValidatedField
                label={translate('activitiesApp.cusine.createdDate')}
                id="cusine-createdDate"
                name="createdDate"
                data-cy="createdDate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('activitiesApp.cusine.modifiedDate')}
                id="cusine-modifiedDate"
                name="modifiedDate"
                data-cy="modifiedDate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/cusine" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default CusineUpdate;
